import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/data.service';

@Component({
  selector: 'app-admin-minio-beallitas',
  templateUrl: './minio-beallitas.component.html',
})
export class MinioBeallitasComponent implements OnInit {
  loading = false;
  saving = false;
  testing = false;

  forras = 'default';
  hasSecret = false;
  secretMask = '';
  tesztEredmeny: { ok: boolean; uzenet: string; bucketok?: string[] } | null = null;

  settings = {
    endPoint: '',
    port: 9000,
    useSSL: false,
    accessKey: '',
    secretKey: '',
    bucket: 'sulinform',
  };

  constructor(private data: DataService, private http: HttpClient) {}

  ngOnInit() {
    this.loadSettings();
  }

  loadSettings() {
    this.loading = true;
    this.http.get<any>('/api/admin/minio-beallitas').subscribe({
      next: (r) => {
        this.forras = r?.forras || 'default';
        this.hasSecret = !!r?.has_secret_key;
        this.secretMask = r?.secret_key_mask || '';
        this.settings = {
          endPoint: r?.endPoint || '',
          port: Number(r?.port) || 9000,
          useSSL: !!r?.useSSL,
          accessKey: r?.accessKey || '',
          secretKey: '', // sosem töltjük vissza a titkot
          bucket: r?.bucket || 'sulinform',
        };
        this.loading = false;
      },
      error: (e) => {
        console.error('MinIO beállítás betöltési hiba:', e);
        this.loading = false;
        this.data.sendToast('Nem sikerült betölteni a MinIO beállításokat.', 'error');
      },
    });
  }

  saveSettings() {
    this.saving = true;
    this.tesztEredmeny = null;
    this.http.put<any>('/api/admin/minio-beallitas', this.settings).subscribe({
      next: (r) => {
        this.forras = r?.forras || 'db';
        this.hasSecret = !!r?.has_secret_key;
        this.secretMask = r?.secret_key_mask || '';
        this.settings.secretKey = '';
        this.settings.accessKey = r?.accessKey || this.settings.accessKey;
        this.saving = false;
        this.data.sendToast('MinIO beállítások mentve és élesítve.', 'success');
      },
      error: (e) => {
        console.error('MinIO beállítás mentési hiba:', e);
        this.saving = false;
        this.data.sendToast(e?.error?.error || 'Nem sikerült menteni a MinIO beállításokat.', 'error');
      },
    });
  }

  testConnection() {
    this.testing = true;
    this.tesztEredmeny = null;
    this.http.post<any>('/api/admin/minio-beallitas/teszt', {}).subscribe({
      next: (r) => {
        this.testing = false;
        if (r?.ok) {
          this.tesztEredmeny = {
            ok: true,
            uzenet: `Kapcsolat OK (${r.endPoint}:${r.port}). „${r.bucket}" bucket ${r.bucketLetezik ? 'létezik' : 'NEM létezik'}.`,
            bucketok: r.bucketok || [],
          };
        } else {
          this.tesztEredmeny = { ok: false, uzenet: r?.error || 'Sikertelen kapcsolat.' };
        }
      },
      error: (e) => {
        this.testing = false;
        this.tesztEredmeny = { ok: false, uzenet: e?.error?.error || 'Sikertelen kapcsolat.' };
      },
    });
  }
}
